export function isUrl(value: string): boolean {
  try {
    const url = new URL(value);
    // Ensure the protocol is either 'http:' or 'https:'.
    // This excludes other protocols like 'ftp:', 'file:', etc.,
    // and focuses only on web URLs.
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
